export { GlobalSearchModalResults } from './GlobalSearchModalResults';
